<template>
  <range
    :label="$t('edit.sidebar.width')"
    min="100"
    max="500"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../general/Range.vue';

export default {
  components: {
    Range,
  },
  methods: {
    value() {
      return this.boxConfig.trigger_button.style.width.replace('px', '');
    },
    onChange(value) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'width',
        value: `${value}px`,
      });
    },
    onMove(value) {
      this.boxPreviewConfigStyleChange({
        item: 'trigger_button',
        rule: 'width',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'boxUpdateConfigStyle',
      'boxPreviewConfigStyleChange',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Width.vue?c233a716
 **/